// extracted by mini-css-extract-plugin
export default {"card":"w4-z","carouselContainer":"x4-z","carouselContainerOverrides":"y4-z","carouselContent":"z4-z"};